import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-recuperar',
  templateUrl: './recuperar.component.html',
  styleUrls: ['./recuperar.component.css']
})
export class RecuperarComponent implements OnInit {


  ngOnInit(): void {
  }
  constructor(
    private router:Router,
    private authServices:AuthService
    ) { }
  username: any
  correo: any
  validarEmail(valor:any) {
    if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(valor)){
        return true;
    } else {
        return false;
    }
  }

  recover(){
    // Utils.loadingTrue();
    const $error=document.querySelector(".error");
    if (!this.validarEmail(this.correo)) {
      $error?.classList.remove("none");
      // notify('Ingrese un correo valido', 'error', 8000);
      return;
    }else{
      let data='Email='+this.correo
      this.authServices.recoveryPassword(data).subscribe({
        next:(res)=>{
          $error?.classList.add("none");
          notify('Se le ha enviado un correo a '+this.correo + ' con su nueva contraseña', 'success', 8000);
        },
        error: (e:HttpErrorResponse)=>{
          console.log(e)
          notify('Se ha presentado un error.', 'error', 8000);
        },
        complete:()=>{this.router.navigate(["index"])}
      })
      // $error?.classList.add("none");
      // notify('Se le ha enviado un correo a '+this.correo + ' con su nueva contraseña', 'success', 8000);
      // this.router.navigate(["login"])
    }
  }
  back(){
    this.router.navigate(["index"])
  }
   

}
